import script from "./LoginBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginBar.vue?vue&type=script&setup=true&lang=ts"

import "./LoginBar.vue?vue&type=style&index=0&id=deff470c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deff470c"]])

export default __exports__